/* --------------------------------------------------------------------------------------
   jobSettings.const.js
   Copyright © 2023 Xerox Corporation. All Rights Reserved.
     
   Copyright protection claimed includes all forms and matters of copyrightable material
   and information now allowed by statutory or judicial law or hereinafter granted,
   including without limitation, material generated from the software programs which
   are displayed on the screen such as icons, screen display looks, etc.
--------------------------------------------------------------------------------------*/

export const apiJobSettingNames = { 
    TwoSided: "duplex", 
    Resolution: "resolution",
    OutputColor: "colorMode",
    OriginalOrientation: "orientation",
    OriginalSize: "originalSize",
    OriginalType: "originalType",
    Quality: "quality"
}

export const pdfSearchLanguages = [
    { key: "cs", translationKey: "FILETYPE.LANG.CS", value: "Czech" },
    { key: "ca", translationKey: "FILETYPE.LANG.CA", value: "Catalan" },
    { key: "da", translationKey: "FILETYPE.LANG.DA", value: "Danish" },
    { key: "nl", translationKey: "FILETYPE.LANG.NL", value: "Dutch" },
    { key: "en", translationKey: "FILETYPE.LANG.EN", value: "English" },
    { key: "fi", translationKey: "FILETYPE.LANG.FI", value: "Finnish" },
    { key: "fr", translationKey: "FILETYPE.LANG.FR", value: "French" },
    { key: "de", translationKey: "FILETYPE.LANG.DE", value: "German" },
    { key: "el", translationKey: "FILETYPE.LANG.EL", value: "Greek" },
    { key: "hu", translationKey: "FILETYPE.LANG.HU", value: "Hungarian" },
    { key: "it", translationKey: "FILETYPE.LANG.IT", value: "Italian" },
    { key: "no", translationKey: "FILETYPE.LANG.NO", value: "Norwegian" },
    { key: "pl", translationKey: "FILETYPE.LANG.PL", value: "Polish" },
    { key: "pt-BR", translationKey: "FILETYPE.LANG.PTBR", value: "Portuguese (Brazil)" },
    { key: "ro", translationKey: "FILETYPE.LANG.RO",  value: "Romanian" },
    { key: "ru", translationKey: "FILETYPE.LANG.RU",  value: "Russian" },
    { key: "es", translationKey: "FILETYPE.LANG.ES",  value: "Spanish" },
    { key: "sv", translationKey: "FILETYPE.LANG.SV",  value: "Swedish" },
    { key: "tr", translationKey: "FILETYPE.LANG.TR",  value: "Turkish" }
]